function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.227,
    height: 17.2,
    viewBox: "0 0 17.227 17.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25986"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24867",
    d: "m12604.779 471.481 5.968 1.8V487.4l-6.76-1.469z",
    transform: "translate(-12603.9 -470.9)",
    style: {
      fill: "#612166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25518"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24862",
    d: "M12.188 18.667H9.354a.354.354 0 0 1 0-.708h2.833A1.064 1.064 0 0 0 13.25 16.9v-3.546a.354.354 0 1 1 .708 0V16.9a1.773 1.773 0 0 1-1.77 1.767z",
    transform: "translate(-2.525 -3.692)",
    style: {
      fill: "#393939",
      stroke: "#393939",
      strokeWidth: ".2px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25519"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24863",
    d: "M20.437 10.708h-7.083a.354.354 0 1 1 0-.708h7.083a.354.354 0 1 1 0 .708z",
    transform: "translate(-3.692 -2.817)",
    style: {
      fill: "#393939",
      stroke: "#393939",
      strokeWidth: ".2px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25520"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24864",
    d: "M5.667 17a1.349 1.349 0 0 1-.452-.077L.972 15.508A1.415 1.415 0 0 1 0 14.167V1.417A1.418 1.418 0 0 1 1.417 0a1.325 1.325 0 0 1 .453.078l4.241 1.414a1.414 1.414 0 0 1 .972 1.342v12.75A1.418 1.418 0 0 1 5.667 17zM1.417.708a.709.709 0 0 0-.708.708v12.75a.708.708 0 0 0 .487.67l4.25 1.417a.706.706 0 0 0 .929-.67V2.833a.705.705 0 0 0-.487-.669L1.638.747a.652.652 0 0 0-.221-.039z",
    transform: "translate(.1 .1)",
    style: {
      fill: "#393939",
      stroke: "#393939",
      strokeWidth: ".2px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25521"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24865",
    d: "M11.417 5.667a.354.354 0 0 1-.354-.354V1.771A1.064 1.064 0 0 0 10 .708H1.854a.354.354 0 0 1 0-.708H10a1.773 1.773 0 0 1 1.771 1.771v3.542a.354.354 0 0 1-.354.354z",
    transform: "translate(-.337 .1)",
    style: {
      fill: "#393939",
      stroke: "#393939",
      strokeWidth: ".2px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25522"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24866",
    d: "M19.354 12.376a.354.354 0 0 1-.251-.6l2.583-2.583L19.1 6.606a.354.354 0 0 1 .5-.5l2.833 2.833a.354.354 0 0 1 0 .5L19.6 12.273a.355.355 0 0 1-.246.103z",
    transform: "translate(-5.442 -1.651)",
    style: {
      fill: "#393939",
      stroke: "#393939",
      strokeWidth: ".2px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1d2c6265c8e6d98c099690aff9eaf479.svg";
export { ForwardRef as ReactComponent };